import { render, staticRenderFns } from "./ViewHistoryItemDetails.vue?vue&type=template&id=9361e126&scoped=true"
import script from "./ViewHistoryItemDetails.vue?vue&type=script&lang=js"
export * from "./ViewHistoryItemDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewHistoryItemDetails.vue?vue&type=style&index=0&id=9361e126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9361e126",
  null
  
)

export default component.exports